import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useState, } from "react";
import { Dialogue } from "./dialogue";
export const DialogueContext = createContext(null);
export const DialogueProvider = ({ children }) => {
    const [config, setConfig] = useState(null);
    const [showDialogue, setShowDialogue] = useState(false);
    const handleClose = () => {
        setShowDialogue(false);
        setConfig(null);
    };
    return (_jsxs(DialogueContext.Provider, Object.assign({ value: { config, setConfig, showDialogue, setShowDialogue } }, { children: [children, showDialogue && _jsx(Dialogue, Object.assign({}, config, { closeDialogue: handleClose }))] })));
};
export const useDialogue = () => {
    const { setConfig, setShowDialogue } = useContext(DialogueContext);
    const showDialogue = (config) => {
        setConfig(Object.assign({}, config));
        setShowDialogue(true);
    };
    const closeDialogue = () => {
        setShowDialogue(false);
        setConfig(null);
    };
    return { showDialogue, closeDialogue };
};
